// Race Duel HUD — overlay shown during daily duel runs.
// Displays the rival's handle + target score plus a live score-delta chip.
import React from "react";
import { Swords } from "lucide-react";

export default function RaceDuelHUD({ rivalHandle, rivalScore, currentScore }) {
  if (!rivalHandle || !rivalScore) return null;
  const delta = (currentScore || 0) - rivalScore;
  const ahead = delta >= 0;
  const color = ahead ? "#39FF14" : "#FF6EC7";
  return (
    <div
      data-testid="race-duel-hud"
      className="absolute top-4 left-1/2 -translate-x-1/2 z-30 flex items-center gap-3 px-4 py-2 bg-black/85 backdrop-blur-md border pointer-events-none"
      style={{
        borderColor: color,
        boxShadow: `0 0 16px ${color}55`,
      }}
    >
      <Swords size={14} style={{ color }} />
      <div className="flex flex-col gap-0.5">
        <div className="text-[8px] tracking-[0.4em] text-white/60">
          DUEL · <span className="text-white/90">{rivalHandle}</span>
        </div>
        <div className="text-xs font-mono tracking-wider flex items-center gap-3">
          <span className="text-white/70">
            TARGET <span className="text-white tabular-nums">{rivalScore}</span>
          </span>
          <span
            data-testid="race-duel-delta"
            className="tabular-nums font-bold"
            style={{ color, textShadow: `0 0 8px ${color}88` }}
          >
            {ahead ? "+" : ""}
            {delta}
          </span>
        </div>
      </div>
    </div>
  );
}
